// extracted by mini-css-extract-plugin
export default {"editor":"fVdk32eXjhXvTu0GjKcF","noEditMode":"Tkh_6_hX4Uy__X2xPUTI","saveButtonSection":"ED8s8PZl23x33S0er_om"};